import { render, staticRenderFns } from "./EWFrequencyShow.vue?vue&type=template&id=2663a6d8&"
import script from "./EWFrequencyShow.vue?vue&type=script&lang=js&"
export * from "./EWFrequencyShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports